module.exports = __webpack_public_path__ + "static/img/li2_6.425cc521.png";